module.exports = __webpack_public_path__ + "img/motorcycle.3d2da1ba.svg";